import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-toolbar-group',
  templateUrl: './toolbar-group.component.html',
  styleUrls: ['./toolbar-group.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarGroupComponent {}
